module.exports = __webpack_public_path__ + "static/media/bg-invite-image.84b66117.svg";